<script lang="ts">
	import {Router} from "svelte-router-spa";
	import routes from "./Core/Routes";
	import {coreStore, alertShown, modalComponent, modalData} from "./Core/Store";
	import {cubicInOut} from "svelte/easing";

	export let currentRoute;
	const { compiledTitle } = coreStore;

	function opacityTransition(node, { duration = 250 }) {
		return {
			duration,
			css: t => {
				const eased = cubicInOut(t);
				return `transform: opacity:${eased}`
			}
		};
	}
	function opacityScaleTransition(node, { duration = 250 }) {
		return {
			duration,
			css: t => {
				const eased = cubicInOut(t);
				return `transform: scale(${(95 + (eased*5))/100}); opacity:${eased}`
			}
		};
	}
</script>

<svelte:head>
	<title>{$compiledTitle}</title>
</svelte:head>

{#if $alertShown}
	<div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
		<div class="flex items-center justify-center min-h-screen p-4 text-center sm:block sm:p-0">
			<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" in:opacityTransition out:opacityTransition aria-hidden="true"></div>
			<span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
			<div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
				in:opacityScaleTransition out:opacityScaleTransition>
				<svelte:component this="{$modalComponent}" data="{$modalData}" />
			</div>
		</div>
	</div>
{/if}

<Router {routes} />